import { getSessionCountry } from "@faire/help-center-utils/serialized-data/getSessionCountry";
import { getDocumentOrThrow } from "@faire/web--source/common/globals/getDocument";
import {
  DEPRECATED_backwardsCompatibleValues,
  useStrictLocalization,
} from "@faire/web--source/common/localization";
import { getCountryDisplayNameFromSessionCountry } from "@faire/web--source/common/localization/getCountryDisplayNameFromSessionCountry";
import React, { useEffect, useRef } from "react";
import { Helmet } from "react-helmet";

export const HelpCenterHelmet = () => {
  const { strictLocalize } = useStrictLocalization();
  const country = getCountryDisplayNameFromSessionCountry(
    getSessionCountry(),
    strictLocalize
  );

  const title = country
    ? strictLocalize(
        {
          defaultMessage: "Faire {country} – Help Center",
          description: {
            text: "Title meta-tag for the Faire Help Center (faire.com/support) with country name",
          },
        },
        DEPRECATED_backwardsCompatibleValues({ country })
      )
    : strictLocalize({
        defaultMessage: "Faire – Help Center",
        description: {
          text: "Title meta-tag for the Faire Help Center (faire.com/support)",
        },
      });

  return <FaireHelmet title={title} />;
};

const FaireHelmet: React.FC<{ title: string }> = ({ title }) => {
  const oldTitle = useRef<string>("");

  useEffect(() => {
    oldTitle.current = getDocumentOrThrow().title;

    return () => {
      getDocumentOrThrow().title = oldTitle.current;
    };
  }, [oldTitle]);

  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};
